/**
 * Author: Claude
 * Generation: Phaser3 frontend development - MenuScene implementation
 * Version: 1.0.0
 * Modified: 2025-08-29 Beijing Time
 */
import * as Phaser from 'phaser';

export class MenuScene extends Phaser.Scene {
  private titleText: Phaser.GameObjects.Text | null = null;
  private menuItems: Phaser.GameObjects.Text[] = [];

  constructor() {
    super({ key: 'MenuScene' });
  }

  preload(): void {
    // No assets needed for placeholder menu
  }

  create(): void {
    const centerX = this.cameras.main.width / 2;
    const centerY = this.cameras.main.height / 2;

    // Main title
    this.titleText = this.add.text(centerX, centerY - 100, 'Agent Battle Royale 3.0', {
      fontSize: '32px',
      color: '#ffffff',
      align: 'center'
    }).setOrigin(0.5);

    this.add.text(centerX, centerY - 60, '100% LLM驱动AI大逃杀直播平台', {
      fontSize: '16px',
      color: '#00ff00',
      align: 'center'
    }).setOrigin(0.5);

    // Menu options
    const menuOptions = [
      { text: '观看实时对战', action: () => this.startBattleMode() },
      { text: '🎭 动画系统演示', action: () => this.startAnimationDemo() },
      { text: '史莱姆战斗演示', action: () => this.startBattleDemo() },
      { text: '回放历史战斗', action: () => this.startReplayMode() },
      { text: '游戏设置', action: () => this.openSettings() }
    ];

    menuOptions.forEach((option, index) => {
      const menuText = this.add.text(centerX, centerY + (index * 40), option.text, {
        fontSize: '18px',
        color: '#ffffff',
        align: 'center'
      }).setOrigin(0.5);

      menuText.setInteractive();
      menuText.on('pointerover', () => {
        menuText.setColor('#00ff00');
      });
      menuText.on('pointerout', () => {
        menuText.setColor('#ffffff');
      });
      menuText.on('pointerdown', option.action);

      this.menuItems.push(menuText);
    });

    console.log('MenuScene created - placeholder mode');
  }

  private startBattleMode(): void {
    console.log('Starting battle mode...');
    this.scene.start('BattleScene');
  }

  private startAnimationDemo(): void {
    console.log('🎭 Starting animation system demo...');
    this.scene.start('AnimationDemoScene');
  }

  private startBattleDemo(): void {
    console.log('Starting battle demo...');
    this.scene.start('BattleDemoScene');
  }

  private startReplayMode(): void {
    console.log('Starting replay mode...');
    this.scene.start('ReplayScene');
  }

  private openSettings(): void {
    console.log('Opening settings...');
    // Settings will be implemented later
  }
}